module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/wigilia/big/5-93249975519ace9c7f31f524ac541088.webp";